import { registerMsgHandler } from "userful-chronos-app-common-js/dist/message/messageRegistery";
import {
    NOTIFY_CLUSTER_STATUS,
    NOTIFY_FAILOVER_STATUS,
    RESPOND_CLUSTER_STATUS,
    RESPOND_FAILOVER_STATUS,
    RESPOND_GET_FAILOVER_CONFIG,
    RESPOND_UPDATE_FAILOVER_CONFIG,
    RESPONSE_FAILBACK,
    RESPONSE_FAILOVER,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/failover/failover";
import {
    FailoverClusterConfig,
    FailoverClusterStateData,
    FailoverStatusData,
} from "userful-chronos-app-common-js/dist/models/failover/failover";
import failoverStore from "../failoverStore";
import { failoverSliceActions } from "../failoverSlice";

//
registerMsgHandler(RESPOND_GET_FAILOVER_CONFIG, (payload) => {
    console.debug("receive RESPOND_GET_FAILOVER_CONFIG");
    const data = JSON.parse(payload) as FailoverClusterConfig;
    failoverStore.dispatch(failoverSliceActions.setFailoverConfig(data));
});

registerMsgHandler(RESPOND_UPDATE_FAILOVER_CONFIG, (payload) => {
    console.debug("receive RESPOND_UPDATE_FAILOVER_CONFIG");
    const data = JSON.parse(payload) as FailoverClusterConfig;
    failoverStore.dispatch(failoverSliceActions.setFailoverConfig(data));
});

registerMsgHandler(RESPONSE_FAILOVER, (payload) => {
    console.debug("receive RESPONSE_FAILOVER");
    const data = JSON.parse(payload) as FailoverStatusData;
    failoverStore.dispatch(failoverSliceActions.setFailoverStatus(data));
});

registerMsgHandler(RESPONSE_FAILBACK, (payload) => {
    console.debug("receive RESPONSE_FAILBACK");
    const data = JSON.parse(payload) as FailoverStatusData;
    failoverStore.dispatch(failoverSliceActions.setFailoverStatus(data));
});

registerMsgHandler(RESPOND_FAILOVER_STATUS, (payload) => {
    console.debug("receive RESPOND_FAILOVER_STATUS");
    const data = JSON.parse(payload) as FailoverStatusData;
    failoverStore.dispatch(failoverSliceActions.setFailoverStatus(data));
});

registerMsgHandler(NOTIFY_FAILOVER_STATUS, (payload) => {
    console.debug("receive NOTIFY_FAILOVER_STATUS");
    const data = JSON.parse(payload) as FailoverStatusData;
    failoverStore.dispatch(failoverSliceActions.setFailoverStatus(data));
});

registerMsgHandler(RESPOND_CLUSTER_STATUS, (payload) => {
    console.debug("receive RESPOND_CLUSTER_STATUS");
    const data = JSON.parse(payload) as FailoverClusterStateData;
    failoverStore.dispatch(failoverSliceActions.setClusterStatus(data));
});

registerMsgHandler(NOTIFY_CLUSTER_STATUS, (payload) => {
    console.debug("receive NOTIFY_CLUSTER_STATUS");
    const data = JSON.parse(payload) as FailoverClusterStateData;
    failoverStore.dispatch(failoverSliceActions.setClusterStatus(data));
});
